import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=850f577c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('850f577c')) {
      api.createRecord('850f577c', component.options)
    } else {
      api.reload('850f577c', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=850f577c&", function () {
      api.rerender('850f577c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/Settings.vue"
export default component.exports